export const STORAGE_KEYS = {
  hasSeenIntro: "the-quest:has-seen-intro",
  settings: "the-quest:settings",
  forceNewGame: "the-quest:force-new-game",
  /** Chapter id to replay from scratch — read once by GameScreen's bootstrap, then cleared. */
  replayChapterId: "the-quest:replay-chapter-id",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
